import * as React from "react";
import { connect, FormikContextType } from "formik";
import { PrimaryButton, TextButtonLink } from "@talentpair/quantic";
import { FilterValuesT } from "./types";

interface EmptyResultsProps {
  checkOrganizations?: boolean;
  formik: FormikContextType<FilterValuesT>;
}
const EmptyResults = ({
  checkOrganizations,
  formik: { values, handleReset, setFieldValue },
}: EmptyResultsProps): React.ReactElement => (
  <div className="p3 grey-border-top">
    <div className="h3 semibold pb3">Looking for more results?</div>
    {(checkOrganizations && !!values.organizations.length) ||
    !!values.locations.length ||
    values.classification.length ||
    values.seniority_scores.length ? (
      <>
        <div>Try removing one of the following filters:</div>
        <div>
          {checkOrganizations && !!values.organizations.length && (
            <PrimaryButton
              classes={{ root: "mt3 mr3" }}
              onClick={() => setFieldValue("organizations", [])}
            >
              Company
            </PrimaryButton>
          )}
          {!!values.locations.length && (
            <PrimaryButton
              classes={{ root: "mt3 mr3" }}
              onClick={() => setFieldValue("locations", [])}
            >
              Location
            </PrimaryButton>
          )}
          {!!values.classification.length && (
            <PrimaryButton
              classes={{ root: "mt3 mr3" }}
              onClick={() => setFieldValue("classification", [])}
            >
              Field of work
            </PrimaryButton>
          )}
          {!!values.seniority_scores.length && (
            <PrimaryButton
              classes={{ root: "mt3" }}
              onClick={() => setFieldValue("seniority_scores", [])}
            >
              Experience level
            </PrimaryButton>
          )}
        </div>
        <div className="mt3">
          Or <TextButtonLink onClick={handleReset}>clear all filters</TextButtonLink>.
        </div>
      </>
    ) : (
      <div>We get new opportunities every day, so check back again soon!</div>
    )}
  </div>
);

export default connect<{ checkOrganizations?: boolean }, FilterValuesT>(EmptyResults);

export const _test = { EmptyResults };
